import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/hooks';
import generateEntry from '../../generates/entry/generateEntry';
/**
 * 진입점 관련 처리 생성 함수를 위한 hook 입니다.
 *
 */
var useEntry = function (time) {
    return useQuery(QUERY_KEYS.ENTRY(time), function () { return generateEntry(); });
};
export default useEntry;
